import React from 'react'
import { useFlag } from '@labrav/flags'
import { useStyles } from './SubscriptionStatus.styles'
import { Typography } from '@mui/material'
import { StatusChipsState } from '@labrav/react-components/lib/@types/v2/components/StatusChips'
import { StatusChips } from '@labrav/react-components'
import {
  Subscription,
  SubscriptionStatusValue,
} from '../../../../modules/subscription/reducer'
import { DateTime } from 'luxon'

export const getStatusAndLabelForSubscription = (
  statusUpdate: SubscriptionStatusValue,
  expiryDate?: string,
  now: () => DateTime = DateTime.now,
  {
    treatPastExpiryAsExpired = false,
  }: { treatPastExpiryAsExpired?: boolean } = {}
) => {
  if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_SUCCESS) {
    if (expiryDate) {
      const dayDiff = Math.ceil(
        DateTime.fromISO(expiryDate).diff(now(), 'days').days
      )
      if (treatPastExpiryAsExpired && dayDiff <= 0) {
        return { status: 'error' as StatusChipsState, label: 'Expired' }
      }
      if (dayDiff > 0 && dayDiff <= 90) {
        return { status: 'warning' as StatusChipsState, label: 'Expiring Soon' }
      }
      return { status: 'success' as StatusChipsState, label: 'Active' }
    }
    return { status: 'success' as StatusChipsState, label: 'Active' }
  } else if (statusUpdate === SubscriptionStatusValue.UNSUBSCRIBE_PENDING) {
    return { status: 'warning' as StatusChipsState, label: 'Expiring Soon' }
  } else if (statusUpdate === SubscriptionStatusValue.UNSUBSCRIBE_SUCCESS) {
    return { status: 'error' as StatusChipsState, label: 'Expired' }
  } else if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_FAIL) {
    return { status: 'error' as StatusChipsState, label: 'Subscription Failed' }
  } else if (statusUpdate === SubscriptionStatusValue.SUBSCRIPTION_PENDING) {
    return { status: 'warning' as StatusChipsState, label: 'Subscribe Pending' }
  } else {
    return { status: 'error' as StatusChipsState, label: 'Expired' }
  }
}

export const SubscriptionStatus = (props: { subscriptions: Subscription }) => {
  const { subscriptions } = props
  const { classes } = useStyles()
  const { flag: contractStatusUpdate } = useFlag('contractStatusUpdate')

  const statusLabel = getStatusAndLabelForSubscription(
    subscriptions.status,
    subscriptions.expirationDate,
    DateTime.now,
    { treatPastExpiryAsExpired: !!contractStatusUpdate?.value }
  )
  return (
    <div className={classes.gridRoot}>
      <Typography className={classes.label}>Subscription status</Typography>
      <div className={classes.statusChip}>
        <StatusChips status={statusLabel.status} label={statusLabel.label} />
      </div>
    </div>
  )
}
